module.exports = __webpack_public_path__ + "img/wechat-icon1.d158fb20.svg";